<input #frontFileInput (change)="onLoadFront($event)" [accept]="acceptFormats" type="file">
<input #backFileInput (change)="onLoadBack($event)" [accept]="acceptFormats" type="file">

<div class="documents-container">

  <button (click)="openAllInfo()" class="document-info-button">
    {{ 'Documents.Example' | translate }}
    <span class="symbol"> &larr; </span>
  </button>

  <div class="document-type horizontal data-field">
    <mat-radio-group (change)="this.onSelectedDocumentChange()" [(ngModel)]="selectedDocument">
      <div *ngFor="let document of documents" class="radio-container">

        <mat-radio-button [value]="document">
          {{ 'Documents.' + document.id + '.Title' | translate }}
        </mat-radio-button>

        <button (click)="openInfo(document)" class="info-button">
          <img alt="info" src="/img/info.svg">
        </button>

      </div>
    </mat-radio-group>
  </div>

  <ng-container *ngIf="selectedDocument">
    <div class="document-info with-icon">
      <img alt="info" src="/img/info-icon.svg">
      <div [innerHTML]="'Documents.' + selectedDocument.id + '.IdentityInfo' | translate | safe:'html'"></div>
    </div>

    <form #documentFormRef [formGroup]="documentForm" class="date-form" id="documentFormRef">
      <div *ngIf="selectedDocument.requiredDate" class="date">
        <app-data-picker (dateChanged)="onDateChanged()"
                         [(dateDay)]="dateDay"
                         [(dateMonth)]="dateMonth"
                         [(dateYear)]="dateYear"
                         [parentForm]="documentForm"
                         [years]="years"
                         dateDayFormName="ddDate"
                         dateMonthFormName="mmDate"
                         dateYearFormName="yyyyDate"
                         label="{{'Documents.' + selectedDocument.id +'.ExpireDate' | translate}}">
        </app-data-picker>

        <mat-error *ngIf="(frontDocument || backDocument) && (isRequiredField('mmDate') || isRequiredField('ddDate') || isRequiredField('yyyyDate'))"
                   class="text-start">
          {{ 'dateOfBirthRequired' | translate }}
        </mat-error>

        <mat-error *ngIf="isPastDateError()" class="text-start">
          {{ 'Documents.ExpireDateInPast' | translate }}
        </mat-error>

      </div>
    </form>

    <div class="upload-container">
      <div *ngIf="selectedDocument.requiredFront" class="file-container">
        <button (click)="frontFileInput.click()" [disabled]="isBusy[additionalDocumentType.ProofIdentityFront]"
                mat-button>

          <ng-container *ngIf="!frontDocument">
            <img alt="attach" src="/img/attach.svg">
            {{ 'Documents.' + selectedDocument.id + '.AttachFront' | translate }}
          </ng-container>

          <ng-container *ngIf="frontDocument">
            <img alt="attach" src="/img/attach.svg">
            {{ 'Documents.AttachedFront' | translate }}
          </ng-container>
        </button>

        <div *ngIf="frontDocument" class="file">
          <button (click)="onRemoveFront()" [disabled]="isBusy[additionalDocumentType.ProofIdentityFront]"
                  class="remove">
            <img alt="remove" src="/img/remove.svg">
          </button>
          <div> {{ frontDocument.fileName }}</div>
          <img alt="mark" src="/img/file.svg">
        </div>
      </div>

      <div *ngIf="selectedDocument.requiredBack" [ngClass]="{'filled': backDocument}" class="file-container">
        <button (click)="backFileInput.click()" [disabled]="isBusy[additionalDocumentType.ProofIdentityBack]"
                mat-button>
          <ng-container *ngIf="!backDocument">
            <img alt="attach" src="/img/attach.svg">
            {{ 'Documents.' + selectedDocument.id + '.AttachBack' | translate }}
          </ng-container>

          <ng-container *ngIf="backDocument">
            {{ 'Documents.AttachedBack' | translate }}
          </ng-container>
        </button>

        <div *ngIf="backDocument" class="file">
          <button (click)="onRemoveBack()" [disabled]="isBusy[additionalDocumentType.ProofIdentityBack]" class="remove">
            <img alt="remove" src="/img/remove.svg">
          </button>
          <div> {{ backDocument.fileName }}</div>
          <img alt="mark" src="/img/mark.svg">
        </div>
      </div>
    </div>
  </ng-container>
</div>
